import sanaUrls from '~/public/data/sana_urls.json' // Import directly

interface ProductData {
  [key: string]: {
    url: string
    title?: string
  }
}

function getShopLocale(nuxtLocale: string): string {
  // Extract the language part from the locale code (e.g., 'ch_de' -> 'de')
  const lang = nuxtLocale.split('_')[1]?.toLowerCase()

  switch (lang) {
    case 'de':
      return 'de-ch'
    case 'en':
      return 'en-us'
    case 'fr':
      return 'fr-ch'
    case 'it':
      return 'it-ch'
    default:
      return 'de-ch' // Fallback for se_sv, pl_pl, or any unmapped locale
  }
}

export async function useLegacyProductUrl(productId: string): Promise<ComputedRef<string | null>> {
  const { locale } = useI18n()
  const baseShopUrl = 'https://shop.wetrok.com'
  // Import the sanaUrls JSON file dynamically. It will bundled for the current session.
  // Fetch from public or nuxt server results in a 404 in ssr request.
  const { default: sanaUrls } = await import('~/data/sana_urls.json')
  return computed(() => {
    const productSlug = (sanaUrls as ProductData)[productId]?.url
    return productSlug ? `${baseShopUrl}/${getShopLocale(locale.value)}/${productSlug}` : null
  })
}
